import React from 'react';
import * as Routes from 'modules/routes';
import axios from 'axios';
import { useModalManager } from '@/components/common/Modal';
import SubmitModal from '@/components/ui/Modal/SubmitModal';

type RemoveLessonModalProps = {
  programTitle: string,
  lessonTitle: string,
  uses: number,
  lessonId: number,
  programLessonId: number,
};

const RemoveLessonModal = ({ lessonId, programLessonId, programTitle, lessonTitle, uses } : RemoveLessonModalProps) => {
  const modalManager = useModalManager();

  const handleDelete = () => {
    const path = Routes.plato_api_program_lesson_path(programLessonId);

    axios.delete(path).then(() => {
      const tableRow = document.getElementById(`unit_lesson_${lessonId}`)
        || document.getElementById(`lesson_${lessonId}`);
      tableRow.remove();
    }).catch(err => console.log(err));
  };

  return (
    <>
      <a
        href="#"
        role="button"
        onClick={modalManager.open}
      >
        Remove
      </a>
      <SubmitModal
        close={modalManager.close}
        headerText="Remove Lesson"
        isOpen={modalManager.isOpen}
        onSubmit={modalManager.close}
      >
        <p className="tw-mb-4">This action will not delete the lesson completely. If you need to recover it, log a request with the software team.</p>
        <p className="tw-mb-4">{`This lesson is used in ${uses - 1} other programs.`}</p>
        <p className="tw-mb-4">
          Are you sure you want to remove
          <span className="tw-font-bold">&nbsp;{`${lessonTitle}`}&nbsp;</span>
          from
          <span className="tw-font-bold">&nbsp;{`${programTitle}`}</span>
          ?
        </p>
        <SubmitModal.SubmitButton
          color="red"
          submittingText="Submitting…"
          onClick={handleDelete}
        >
          Yes, remove lesson
        </SubmitModal.SubmitButton>
      </SubmitModal>
    </>
  );
};
export default RemoveLessonModal;
